<template>
  <div class="ma-4">
    <div class="mb-3">
      <span class="main-title">ORDER RECEIPT |</span>
      <span class="submain-title">Food Delivery receipt</span>
    </div>
    <foodReceiptList />
  </div>
</template>

<script>
import foodReceiptList from "@/components/back-office/Report/FoodReceiptListTable";
export default {
  components: {
    foodReceiptList
  },
  destroyed() {
    this.$store.commit("fetchReportFood/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard"
      },
      {
        text: "Food delivery receipt",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/order_report_food"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
